var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.52602V13.4629C17.5 14.0682 17.2618 14.6506 16.8342 15.0906C16.4067 15.5305 15.8221 15.7948 15.2005 15.829L15.0625 15.8327H4.9375C4.3149 15.8327 3.71588 15.6011 3.26333 15.1854C2.81078 14.7697 2.539 14.2014 2.50375 13.5971L2.5 13.4629V7.52602L9.739 11.2127C9.81953 11.2537 9.90909 11.2751 10 11.2751C10.0909 11.2751 10.1805 11.2537 10.261 11.2127L17.5 7.52602ZM4.9375 4.16602H15.0625C15.6667 4.16594 16.2494 4.38403 16.6975 4.77798C17.1457 5.17193 17.4274 5.71366 17.488 6.2981L10 10.1116L2.512 6.2981C2.57014 5.73687 2.83229 5.21421 3.25131 4.82406C3.67034 4.43392 4.21876 4.20188 4.798 4.16966L4.9375 4.16602H15.0625H4.9375Z",
    fill: "#7456CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.38ddb624b3be928f08df66993278a77b.svg";
export { ForwardRef as ReactComponent };